import { RunStatusBadge } from '@/components/MonitoringView/RunsSidebar/RunStatusBadge';
import { MonitoringListItem } from '@/components/MonitoringView/shared/MonitoringListItem';
import { formatDateTime, useRelativeTime, formatDuration } from '@/utils/dateTime';
import { Flash16Filled } from '@fluentui/react-icons';
import { WorkflowRunsPanelStyles } from './WorkflowRunsPanel.styles';
import type { Run } from '@/types/monitoring';

type RunCardProps = {
  run: Run;
  isSelected: boolean;
  isFocused: boolean;
  onSelect: (runId: string) => void;
  onRef: (id: string, el: HTMLDivElement | null) => void;
};

export const RunCard = ({ run, isSelected, isFocused, onSelect, onRef }: RunCardProps) => {
  const styles = WorkflowRunsPanelStyles();

  const relativeTime = useRelativeTime(run.startTime);

  const meta = (
    <>
      {formatDateTime(run.startTime, 'adaptive')}
      {run.isDraftRun && (
        <span className={styles.draftIndicator}>
          {' · '}
          <Flash16Filled className={styles.draftIcon} />
          Draft
        </span>
      )}
      {run.isAgentic && ` · ${run.executionCount} turn${run.executionCount !== 1 ? 's' : ''}`}
    </>
  );

  return (
    <MonitoringListItem
      id={run.id}
      status={run.status}
      primaryText={relativeTime}
      badge={<RunStatusBadge status={run.status} size="small" />}
      metaText={meta}
      trailingText={formatDuration(run.duration, { fallback: '--' })}
      isSelected={isSelected}
      isFocused={isFocused}
      onSelect={onSelect}
      onRef={onRef}
      tooltipContent={formatDateTime(run.startTime, 'weekday')}
    />
  );
};
